import { render } from "./koparkaWynikSkelet.vue?vue&type=template&id=c56b6286&scoped=true"
const script = {}

import "./koparkaWynikSkelet.vue?vue&type=style&index=0&id=c56b6286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56b6286"]])

export default __exports__